import React, { useContext } from "react"
import styled, { ThemeContext } from "styled-components"
import { useTranslation } from "react-i18next"
import { MEDIA_MIN_X_LARGE } from "../../constants"
import Link from "../Link"
import GoToTopButton from "../ui/GoToTopButton"

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 2rem 3rem;
  justify-content: center;
  color: ${(p) => p.theme.colors.black};
  background-color: ${(p) => p.theme.colors.backgroundDark};
  font-size: 1.3rem;
  text-align: center;
  line-height: 1.8rem;
  position: relative;

  span {
    width: 100%;
  }

  ${MEDIA_MIN_X_LARGE} {
    height: 6rem;
    padding: 0;
    padding-top: 0;
    align-items: center;
    flex-wrap: nowrap;

    span {
      width: auto;
    }
  }
`

const BottomBarLink = styled(Link)`
  margin: 0.5rem;
  color: ${(p) => p.theme.colors.black};
  display: inline-block;

  ${MEDIA_MIN_X_LARGE} {
    margin: 0 0.5rem;
  }
`

const Separator = styled.span`
  display: none;

  ${MEDIA_MIN_X_LARGE} {
    margin: 0 1rem 0;
    border-right: 0.1rem solid;
    display: inline-block;
    height: 1.5rem;
  }
`

const BottomBar = () => {
  const { t } = useTranslation("translations")
  const { colors } = useContext(ThemeContext)

  return (
    <Container>
      <span>© 2021 Rondure</span>
      <Separator />
      <span>
        <BottomBarLink
          to="/terms-and-conditions/"
          underline
          color={colors.black}
          title={t("Terms & Conditions")}
        >
          {t("Terms & Conditions")}
        </BottomBarLink>
      </span>
      <Separator />
      <span>
        <BottomBarLink
          to="/data-protection/"
          underline
          color={colors.black}
          title={t("Data protection")}
        >
          {t("Data protection")}
        </BottomBarLink>
      </span>
      <Separator />
      <span>
        <BottomBarLink
          to="/cookie-policy/"
          underline
          color={colors.black}
          title={t("Cookie policy")}
        >
          {t("Cookie policy")}
        </BottomBarLink>
      </span>
      <GoToTopButton />
    </Container>
  )
}

export default BottomBar
